// Profil du coach unique de la plateforme.
//
// NOTE INTERNE (invisible pour les visiteurs) : ces valeurs sont provisoires et
// destinées à être remplacées par les informations réelles. Les paliers, le
// nombre de séances et les années d'expérience doivent correspondre à ce qui
// est démontrable avant toute prise de réservation payante.

export const COACH = {
  name: "Kairo",
  tagline: "Dix ans de compétition, cinq jeux, une méthode : regarder vos parties à vous.",
  intro: [
    "Je joue en compétition depuis 2016 et je coache depuis 2020. J'ai commencé sur Counter-Strike, puis j'ai élargi à League of Legends et Call of Duty en accompagnant des joueurs qui voulaient passer du niveau « bon en soirée » au niveau classé sérieux.",
    "Mes séances ne ressemblent pas à une vidéo de conseils génériques. Je regarde vos parties, je repère ce qui revient, et je vous donne deux ou trois choses à corriger — pas quinze. C'est moins spectaculaire, mais c'est ce qui fait monter.",
  ],
  games: [
    { slug: "league-of-legends", label: "League of Legends", level: "Maître", note: "Jungle et support. Lecture de carte, timings d'objectif, coordination d'équipe." },
    { slug: "counter-strike-2", label: "Counter-Strike 2", level: "Premier 18 000+", note: "Entry et capitaine. Utilitaires, prise d'information, exécutions de site." },
    { slug: "call-of-duty", label: "Call of Duty", level: "Iridescent", note: "Recherche et Destruction, Domination. Placements et rotations." },
    { slug: "fortnite", label: "Fortnite", level: "Champion", note: "Zero Build et Arena. Gestion de zone et fins de partie." },
    { slug: "ea-fc", label: "EA FC", level: "Division 1", note: "Ultimate Team. Construction de jeu, transitions, phases arrêtées." },
  ],
  credentials: [
    "Dix ans de jeu compétitif, dont six en équipe structurée.",
    "Plus de 400 séances de coaching données depuis 2020.",
    "Joueurs accompagnés de l'Or au Maître sur League of Legends, et du Nova au Global sur Counter-Strike.",
    "Préparation de cinq équipes amateurs à des tournois en ligne.",
  ],
  method: [
    { title: "On cadre l'objectif", text: "Une séance sans objectif précis se dilue. On commence par nommer ce qu'on veut corriger, et on s'y tient pendant l'heure." },
    { title: "On regarde votre jeu", text: "Vos parties, vos décisions, vos erreurs récurrentes. Pas des conseils trouvables dans n'importe quelle vidéo." },
    { title: "Vous repartez avec des consignes", text: "Deux ou trois choses à appliquer, formulées pour que vous puissiez les travailler seul jusqu'à la prochaine fois." },
  ],
  availability: "Du lundi au samedi, 18 h – 23 h (heure de Paris). Créneaux en journée le week-end sur demande.",
  languages: ["Français", "Anglais"],
};

// Les cinq jeux couverts. Toute la plateforme lit cette liste.
export const GAMES = [
  { slug: "league-of-legends", label: "League of Legends", short: "LoL", fps: false },
  { slug: "counter-strike-2", label: "Counter-Strike 2", short: "CS2", fps: true },
  { slug: "call-of-duty", label: "Call of Duty", short: "CoD", fps: true },
  { slug: "fortnite", label: "Fortnite", short: "Fortnite", fps: true },
  { slug: "ea-fc", label: "EA FC", short: "EA FC", fps: false },
];
